import React, { useEffect, useState } from "react"
import styled from "styled-components"
import StackedLineChart from "../Charts/StackedLineChart"
import axios from "axios"
import StackedLineChart2 from "../Charts/StackedLineChart2"
import StackedLineChart3 from "../Charts/StackedLineChart3"

const Wrapper = styled.div`
  display: flex;
  width: 340px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;

  border-radius: 16px;
  border: 1px solid var(--base-gray40, #bfbfbf);
  background: var(--base-white100, #fff);
`

const Graph5 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;

  color: var(--base-gray90, #404040);
  font-family: SUIT;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

const Weekly = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
`

const Legend = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  color: var(--base-gray100, #262626);
  font-family: SUIT;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

const Graph = styled.div`
  display: flex;
  width: 308px;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
`

export interface JeongeupMonitoringData {
  groupedDataThisWeek: any
  groupedDataLastWeek: any
  sumThisMonth: any
  sumLastMonth: any
  sumLastYear: any
}

const CardFrame5Renewable = () => {
  const [data, setData] = useState<JeongeupMonitoringData>({
    groupedDataThisWeek: [],
    groupedDataLastWeek: [],
    sumThisMonth: [],
    sumLastMonth: [],
    sumLastYear: [],
  })

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/smart-farm/monitoring`
        )

        setData(response.data)
      } catch (error) {
        console.error("Error fetching dashboard data:", error)
      }
    }

    fetchData()
  }, [])

  return (
    <Wrapper>
      <Graph5>
        비교 에너지 생산량 그래프
        <Weekly>
          <Legend>
            <LegendItem>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <circle cx="7" cy="7" r="5" stroke="#3957D3" stroke-width="4" />
              </svg>
              금주
            </LegendItem>
            <LegendItem>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <circle cx="7" cy="7" r="5" stroke="#BFBFBF" stroke-width="4" />
              </svg>
              전주
            </LegendItem>
          </Legend>
          <Graph>
            <StackedLineChart
              width="100%"
              height="100%"
              currentWeekData={data.groupedDataThisWeek}
              lastWeekData={data.groupedDataLastWeek}
              dataKey="발전"
            />
          </Graph>
        </Weekly>
        <Weekly>
          <Legend>
            <LegendItem>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <circle cx="7" cy="7" r="5" stroke="#3957D3" stroke-width="4" />
              </svg>
              금월
            </LegendItem>
            <LegendItem>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <circle cx="7" cy="7" r="5" stroke="#BFBFBF" stroke-width="4" />
              </svg>
              전월
            </LegendItem>
          </Legend>
          <Graph>
            <StackedLineChart2
              width="100%"
              height="100%"
              currentMonthData={data.sumThisMonth} // 금월 데이터 배열
              lastMonthData={data.sumLastMonth} // 전월 데이터 배열
              dataKey="발전(Wh)"
            />
          </Graph>
        </Weekly>
        <Weekly>
          <Legend>
            <LegendItem>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <circle cx="7" cy="7" r="5" stroke="#3957D3" stroke-width="4" />
              </svg>
              금년
            </LegendItem>
            <LegendItem>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <circle cx="7" cy="7" r="5" stroke="#BFBFBF" stroke-width="4" />
              </svg>
              전년
            </LegendItem>
          </Legend>
          <Graph>
            <StackedLineChart3
              width="100%"
              height="100%"
              currentMonthData={data.sumThisMonth} // 금월 데이터 배열
              lastYearMonthData={data.sumLastYear} // 전월 데이터 배열
              dataKey="발전(Wh)"
            />
          </Graph>
        </Weekly>
      </Graph5>
    </Wrapper>
  )
}

export default CardFrame5Renewable
